import React, { useState } from "react";
import Select from "react-select";
import "./multiselect.scss";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const MultiSelectInput = ({
  label,
  options,
  value = [],
  onChange,
  onCreateOption,
  hideNoOptions = false,
  formatCreateLabel,
  componentsOverload,
  className,
  isCreatable = false,
  isDropDownVisible = false,
  isCaseSensitive = false,
}) => {
  const [inputValue, setInputValue] = useState();

  if (value === undefined || value === null) {
    value = [];
  }

  var SelectComponent = isCreatable ? CreatableSelect : Select;

  const onInputChange = (textInput, { action }) => {
    if (action === "input-change") {
      // Normalize textinput
      var textNormalized = textInput.trim();

      // Parse already added commas
      if (textNormalized && textNormalized.includes(",")) {
        var newValues = textNormalized.split(",");
        newValues = newValues.map((s) => s.trim());
        newValues = newValues.filter((s) => !isEmpty(s));

        var endsWithComma = textNormalized.endsWith(",");

        if (endsWithComma) {
          setInputValue("");
        } else {
          setInputValue(newValues.pop());
        }

        if (isCreatable) {
          onCreateOption(newValues);
        }
      } else {
        setInputValue(textInput);
      }
    }
  };

  // Merge Classnames
  className = `text-grigora-base ${className}`;

  const DropDown = ({ children, ...props }) => {
    return (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faChevronDown} />
        {children}
      </components.DropdownIndicator>
    );
  };

  return (
    <div className={className}>
      {label ? <div className="text-ui-text-heading mb-2">{label}</div> : ""}
      <SelectComponent
        classNames={{
          indicatorsContainer: () =>
            isDropDownVisible ? "dropdown-visible" : "dropdown-hidden",
        }}
        classNamePrefix={`multiselect-ui`}
        value={value}
        options={options}
        onChange={onChange}
        isValidNewOption={(inputValue, selectedValues, selectOptions) => {
          if (!inputValue) {
            return false;
          }

          if (
            selectedValues.some((selected) => {
              if (isCaseSensitive) {
                return selected.label === inputValue;
              }
              return selected.label.toLowerCase() === inputValue.toLowerCase();
            })
          ) {
            return false;
          }

          if (
            selectOptions.some((selected) => {
              if (isCaseSensitive) {
                return selected.label === inputValue;
              }
              return selected.label.toLowerCase() === inputValue.toLowerCase();
            })
          ) {
            return false;
          }

          return !selectOptions.some((selected) => {
            if (isCaseSensitive) {
              return selected.label === inputValue;
            }
            return selected.label.toLowerCase() === inputValue.toLowerCase();
          });

          // var unselectedValues = selectOptions.filter((item) =>
          //   selectValue.some((selected) => {
          //     if (!isCaseSensitive) {
          //       return (
          //         selected.label.toLowerCase() === item.label.toLowerCase()
          //       );
          //     } else {
          //       return selected.label === item.label;
          //     }
          //   }),
          // );
          // console.log(unselectedValues);
          // return !unselectedValues.some((item) => {
          //   if (!isCaseSensitive) {
          //     return inputValue === item.label;
          //   } else {
          //     return inputValue.toLowerCase() === item.label.toLowerCase();
          //   }
          // });
        }}
        inputValue={inputValue}
        isMulti
        onCreateOption={(newVal) => {
          onCreateOption(newVal);
          setInputValue("");
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: "var(--color-ui-light-blue-background)",
            primary: "black",
          },
        })}
        // menuIsOpen={true}
        formatCreateLabel={formatCreateLabel}
        noOptionsMessage={hideNoOptions ? () => null : undefined}
        components={{
          ...components,
          ...componentsOverload,
          DropdownIndicator: DropDown,
        }}
        onInputChange={onInputChange}
      />
    </div>
  );
};

export default MultiSelectInput;
